import {  Button, Card, Col, Container, Grid, Row, Spacer, Table, Text } from '@nextui-org/react';
import axios from 'axios';
import React,{ useState,useEffect, Fragment, useRef } from 'react';
import { eventSeatsLeft, eventURL,publicEventURL,schoolPublicURL, WorkshopPublicURL } from '../../../apis/urls';
import { $ } from "react-jquery-plugin";
import moment from 'moment';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {decode} from 'html-entities'
import { Modal, Loader, Placeholder } from 'rsuite';
import { SmileOutlined } from '@ant-design/icons';
import { Button as Buttons, Result , Modal as Modals,message as messages} from 'antd';
import AttendeePaymentSeminar from './paymentAttendeeSeminar';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import { ButtonGroup,DatePicker as DatePickers, Dropdown, Input,Panel, Steps, Checkbox, InputGroup, Progress, InputNumber, InputPicker, Message, Form, DateRangePicker } from "rsuite";




    
const PublicRegisteringSeminar =()=> {


  const [modal1Open, setModal1Open] = useState(false);
  const [modal2Open, setModal2Open] = useState(false);
  const handleClosePayment = () => setModal1Open(false)

  const [open, setOpen] = React.useState(false);
  const [rows, setRows] = React.useState(10);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  const handleEntered = () => {
    setRows(10);
  };


  const search = useLocation().search;

  const eventid = new URLSearchParams(search).get("event");



  const [result, setResult] = useState('');
  const [resultschool, setResultSchool] = useState([]);
  const [resultValid, setResultValid] = useState([]);
  const [dateDead, setDateDead] = useState('');
  const [activeSession, setActiveSession] = useState('');
  const [workSession, setWorkSession] = useState([]);

  const [school, setSchool] = useState(0);
  const [fname, setFname] = useState('');
  const [lname, setLname] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [regorg, setRegOrg] = useState('');
  const [conorg, setConOrg] = useState('');
  const [regtit, setRegTit] = useState('');
  const [regspe, setRegSpe] = useState('');

  const [orgName, setOrgName] = useState('');
  const [orgCity, setOrgCity] = useState('');
  const [orgState, setOrgState] = useState('');
  const [states,setStates] = useState('GA');
  const [orgCountry, setOrgCountry] = useState('');

  const [addAtten, setAddAtten] = useState(false);


  const [memPrice, setMemPrice] = useState('');
  const [nonmemPrice, setNonMemPrice] = useState('');

  const [deadDateProceed, setDeadDateProceed] = useState(true);

  const [modelMember, setModelMem] = useState('')
  const [modelNonMem, setModelNonMem] = useState('')
  const [latePri, setLatePri] = useState('');
  

 
  const [nonMem, setNonmem] = useState(false);

  let navigate = useNavigate(); 

  useEffect(()=>{
      $('body').removeClass('').addClass('sidebar-collapsed');
      publicEventView();
      SchoolListing();
      eventDataView();
      // WorkshopListing();
  },[])

  const [emailFormat1, setEmailFormat1] = useState({status:false, index:1})




  const publicEventView = () => {

      const instance = axios.create({
          baseURL: eventURL +'/'+ eventid,
          timeout: 1000000,
      });

      instance.get('').then((response) =>{
          console.log(response.data.data)
          
          if(response.data.data.publish_status!=="PUBLISHED")
          {
            messages.error("This event is no longer accepting registration")
            setTimeout(() => {
              window.open('https://gisaschools.org/events/','_self');
            }, 3000);
            setResult(response.data.data);
          }
          else 
          {
            setResult(response.data.data);
            let dates =new Date();

            let datess = moment(dates).format("YYYY-MM-DD")
         
          
            if(response.data.data.registration_deadline <  datess){
              setDateDead(response.data.data.late_registration_price)
              setDeadDateProceed(false)

            }
          }


      }).catch((error) =>{     
          console.log('error',error.message)  
      });
  }




  const SchoolListing = () => {

    const instance = axios.create({
        baseURL: schoolPublicURL,
        timeout: 1000000,
    });
    instance.get('').then((response) =>{
      // console.log(response.data.data)
      setResultSchool(response.data.data)
    }).catch((error) =>{     
        console.log('error',error.message)  
    });
}





const eventDataView = (id) => {

  const instance = axios.create({
      baseURL: eventURL+"/"+eventid,
      timeout: 1000000,
  });
  instance.get('').then((response) =>{
        setResultValid(response.data.data.validation.registrants_title_school);
  }).catch((error) =>{     
      console.log('error',error.message)  
  });
}

/////////















const [ferr, setFerr] = useState(false);
const [ferrind, setFerrind] = useState('');
const [lerr, setLerr] = useState(false);
const [lerrind, setLerrind] = useState('');
const [eerr, setEerr] = useState(false);
const [eerrind, setEerrind] = useState('');
const [perr, setPerr] = useState(false);
const [perrind, setPerrind] = useState('');
const [terr, setTerr] = useState(false);
const [terrind, setTerrind] = useState('');
const [schoolErr, setSchoolErr] = useState(false);




const [inputFields, setInputFields] = useState([
  {firstname:'',lastname: '',email:'',phone:'', con_org:'', title:'', workshop:[] }
]);

const addToAttendee =(e)=>{

  setAddAtten(!addAtten)

  if(!addAtten){

    const values = [...inputFields];

    values[0].firstname = fname
    values[0].lastname = lname
    values[0].email = email
    values[0].phone = phone
    values[0].title = regtit

    setInputFields(values);

    console.log("values", values[0])


  }else{


    const values = [...inputFields];

    values[0].firstname = ''
    values[0].lastname = ''
    values[0].email = ''
    values[0].phone = ''
    values[0].title = ''

    setInputFields(values);

    console.log("values", values[0])

  }

  if(e){


  }else{
    

    
  }
}


const handleAddFields = (index) => {
  const values = [...inputFields];

  values.push({ firstname:'',lastname: '',email:'',phone:'', title:'', workshop:[]});

  if(values[index].firstname ==='' || values[index].lastname ==='' || values[index].email ===''  || values[index].phone ===''  || values[index].title ==='' && resultValid ==='REQUIRED' )
  {

  }else{   

    console.log(inputFields.length)

      setInputFields(values);
  }



    if(inputFields[index].firstname ===''){
      setFerrind(index)
      setFerr(true)
    }else{
      setFerr(false)
    }
    if(inputFields[index].lastname ===''){
      setLerrind(index)
      setLerr(true)
    }else{
      setLerr(false)
    }
    if(inputFields[index].email===''){
      setEerrind(index)
      setEerr(true)
    }else{
      setEerr(false)
    }
    if(inputFields[index].phone===''){
      setPerrind(index)
      setPerr(true)
    }else{
      setPerr(false)
    }
    if(inputFields[index].title==='' && resultValid === 'REQUIRED'){
      setTerrind(index)
      setTerr(true)
    }else{
      setTerr(false)
    }



};


const handleRemoveFields = index => {

  const values = [...inputFields]; // TODO : Remove Attendee
  values.splice(index, 1);
  setInputFields(values);

};


const handleInputChange = (index, event) => {

  const values = [...inputFields];

  

  const emailRegex = /\S+@\S+\.\S+/;

  if(event.target.name === "email"){

      if (emailRegex.test(event.target.value)) {
        setEmailFormat1({status:false, index:index})
        let news = {status:false, index:index}

        console.log(news)
      } else {
        setEmailFormat1({status:true, index:index})
        let news = {status:true, index:index}
        console.log(news)
      }
  }


  if (event.target.name === "firstname") {
    values[index].firstname = event.target.value;
  } else if(event.target.name === "lastname"){
    values[index].lastname = event.target.value;
  } else if(event.target.name === "email"){
    values[index].email = event.target.value;
  } else if(event.target.name === "phone") {
    values[index].phone = event.target.value;
  }else if(event.target.name === "title") {
    values[index].title = event.target.value;
  }

  setInputFields(values);
};

const handleSubmit = e => {
  e.preventDefault();
  // handle form submission here
  // console.log("handleSubmit")
  // alert(JSON.stringify(inputFields, null, 2))
};

const resetForm = e => setInputFields([{ firstname: '', lastname: '', email:'', phone:'', reg_org: '', con_org:'', title:'', spec:'' }])



const [fnameVal, setFnameVal] = useState(false)
const [lnameVal, setLnameVal] = useState(false)
const [emailVal, setEmailVal] = useState(false)
const [phoneVal, setPhoneVal] = useState(false)
const [regOrgVal, setRegOrgVal] = useState(false)
const [conOrgVal, setConOrgVal] = useState(false)
const [titVal, setTitVal] = useState(false)
const [speVal, setSpeVal] = useState(false)

const [statesErr,setStatesErr] = useState(false);

const statess = ["AL","AK","AS","AR","AZ","CA","CO","CT","DE","DC","FM","FL","GA","GU","HI","ID","IL","IN","IA","KS","KY","LA","ME","MH","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PW","PA","PR","RI","SC","SD","TN","TX","UT","VT","VI","VA","WA","WV","WI","WY"];

const ValidationalFuction =()=>{

    if(fname===''){
      // alert('firstname error')
    }else if(lname===''){
      // alert('lastname error')
    }else if(email===''){
      // alert('email error')
    }else if(phone===''){
      // alert('phone error')
    }else{
  
        ValdationgFunc();
    }

    if(school === "0" || school === 0){
      setSchoolErr(true)
    }else{
      setSchoolErr(false)
    }

    if(fname===''){
      setFnameVal(true)
    }
    else{
      setFnameVal(false)
    }
    if(lname===''){
      setLnameVal(true)
    }
    else{
      setLnameVal(false)
    }
    if(email===''){
      setEmailVal(true)
    }
    else{
      setEmailVal(false)
    }
    if(phone===''){
      setPhoneVal(true)
    }
    else{
      setPhoneVal(false)
    }
    
    if(regtit==='' && resultValid === 'REQUIRED'){
      setTitVal(true)
    }
    else{
      setTitVal(false)
    }

    if(states === ''){
      setStatesErr(true)
  }else{
      setStatesErr(false)
  }




  // console.log(inputFields)

}


const [newData, setNewData] = useState([])

const  ValdationgFunc =()=>{

  const data = {
    eventid: eventid,
    schoolid: school === "Non-member Organization"? 0:school,
    firstname:fname,
    lastname:lname,
    email:email,
    phone:phone,
    title:regtit,
    attends: inputFields,
    org_name:orgName,
    org_city:orgCity,
    org_state:states,
    org_country:orgCountry
  }

  let inputLgt = inputFields.length - 1
      
  let errors = 0;
  
  for(let i = 0; i<= inputLgt; i++){
  console.log(data.attends[i].firstname)
  
   if(data.attends[i].firstname ===''){
        setFerrind(i)
        setFerr(true)
        errors = 1;
   }else{
        setFerrind(i)
        setFerr(false)
   }
   if(data.attends[i].lastname ===''){
        setLerrind(i)
        setLerr(true)
        errors = 1;
  
   }else{
        setLerrind(i)
        setLerr(false)
   }
   if(data.attends[i].email ===''){
        setEerrind(i)
        setEerr(true)
        errors = 1;
   }else{
        setEerrind(i)
        setEerr(false)
   }
   if(data.attends[i].phone ===''){
        setPerrind(i)
        setPerr(true)
        errors = 1;
    }else{
        setPerrind(i)
        setPerrind(false)
    }
   
  
   if(data.attends[i].title ==='' && resultValid === 'REQUIRED'){
        setTerrind(i)
        setTerr(true)
        errors = 1;
   }else{
        setTerrind(i)
        setTerr(false)
   }
    
  }
  
   
  if(school === 0 || school === "0")
  {
    return 
  } 
  if(errors === 0){
    if(result?.participant_price > 0){
      handleOpen()
    }else{
      RegisterPayment('FREE', "SUCCESS")
    }
  }


}



  const selectSchool =(e)=>{

  setSchool(e.target.value)
  

  if(e.target.value === 'Non-member school'){
    setNonmem(true)
  }else{
    setNonmem(false)

  }

  }


 const [message,setMessage] = useState('')

  const callbackFunction = (childData) => {
    setMessage(childData);
  };

  const [indexRem, setIndexRem] = useState('')
  const callbackFunctionIndex = ( indexValue) => {
    // console.log("sasasas", indexValue)
    setIndexRem(indexValue)
  };

  const [indexItem, setIndexItem] = useState('')
  const callbackIndexValue = (index) => {
    // console.log("sasasas", index)
    setIndexItem(index)
  };

  const [emailValid, setEmailValid] = useState(false)
  


  const emailRegex = /\S+@\S+\.\S+/;

  const emailValidation =(event)=>{
    if (emailRegex.test(event)) {
      setEmailValid(false)
    } else {
      setEmailValid(true)
    }
}




  const RegisterPayment = (ptype, paymentStatus) => {

    const data = {
      eventid: eventid,
      schoolid: school === "Non-member Organization"? 0:school,
      firstname:fname,
      lastname:lname,
      email:email,
      phone:phone,
      title:regtit,
      payment_type:ptype,
      payment: paymentStatus,
      attendee: inputFields,
      org_name:orgName,
      org_city:orgCity,
      org_state:states,
      org_country:orgCountry,
      attendees: inputFields.length,
    }
  
  
  
    const instance = axios.create({
        baseURL: publicEventURL+'/'+eventid,
        timeout: 1000000,
    });
    instance.post('', data).then((response) =>{

        if(response.data.message === "no seats left"){

          messages.warning("No Seat left")
          handleClose();

          setTimeout(() => {
            window.location.replace('https://gisaschools.org/events')
          }, 1000);

        }else{

          setOpen(false)

          if(ptype === "ONLINE"){
            setModal1Open(true)
            setOpen(false)
  
            let payData = {
              regid:response.data.data.id,
              attendee: inputFields,
              schoolid:school,
              orgname: orgName,
              id: eventid,
              firstname:fname,
              lastname:lname,
              email:email,
              phone:phone,
              amount: nonMem? parseInt(result.non_member_price) + dateDead : result.participant_price + dateDead,
              attendees: inputFields.length,
            }
          
            setNewData(payData)
          }else{
            setOpen(false)
            messages.success("Registration Successfully Completed")

            console.log(result.non_member_price,  typeof result.non_member_price , dateDead, typeof dateDead, result.participant_price, typeof result.participant_price)

          
          
            // const schoolname = resultschool.find(e=>e.id===JSON.parse(school));

            let schoolname;
            if (school === "Non-member school") {
              schoolname = orgName; // Or whatever default value you want
            } else {
              schoolname = resultschool.find(e => e.id === JSON.parse(school))?.name;
            }
            

            
            let checkData = {
              eventname:decode(result.title),
              attendee: inputFields.length,
              amount: nonMem?JSON.parse(result.non_member_price) + dateDead : result.participant_price + dateDead,
              startdate : result.start_date,
              enddate : result.end_date,
              location : result.location,
              schoolid:school,
              orgname: orgName,
              id:result.id,
              attendees: inputFields, 
              schoolnameis : schoolname,
              
             
               
              
            }

            localStorage.setItem('pdfData', JSON.stringify(checkData))
            navigate('/check_payment_form')
          }


        }
  
    }).catch((error) =>{     
        console.log('error',error.message)  
    });
  
  
}




const desc = decode(result.description);
const decrypted_desc = ReactHtmlParser(desc)



  return (

    <div class="wrapper">


    <aside class="right-side">

      
    <div class="content-area no-header">

        <div class="event-details-wrpr" style={{margin:"auto"}}>
					
          <div class="row">
            <div class="col-md-12">
              <div class="row event-basic-details-wrpr">
                <div class="col-md-6">
                  <div className='img-wrpr'>
                    <img src={result.image?result.image:null} style={{width:'100%', height:'100%', objectFit:'cover'}} width="" height="" alt="" />
                  </div>
                </div>
                <div class="col-md-6 event-basic-details">
                  
                  <h2>{decode(result.title)}</h2>

                  <div class="date-time-seats">
                      <div class="date-time">
                        <label>Date &amp; Time</label>
                        <div class="starttime-endtime">
                          <div class="starttime">{moment(result.start_date).format('ddd, MMM DD, YYYY hh:mm A')}</div>
                          <i class="icon-arrow-right1"></i>
                          <div class="endtime">{moment(result.end_date).format('ddd, MMM DD, YYYY hh:mm A')}</div>
                        </div>
                      </div>
                      <div class="date-time">
                        <label>Seats</label>
                        <div class="starttime-endtime">
                        {
                          result.max_number_attendees - result.attendee_count > 0 ? result.max_number_attendees - result.attendee_count + " Seats Left" : "No Seats Left"
                        }
                        </div>
                      </div>
                  </div>

                  <div class="location-wrpr">
                      <label>Location</label>
                      <div class="loc-content">
                          {result.location}
                      </div>
                  </div>
                  
                  <div class="fees-wrpr">
                    <div class="member-fee">
                      <label>Member school Registration Fee</label>
                      <div class="fee-content">
                        ${result.participant_price}
                      </div>
                    </div>
                    <div class="non-member-fee">
                      <label>Non-Member school Registration Fee</label>
                      <div class="fee-content text-right">
                        ${result.non_member_price}
                      </div>
                    </div>
                  </div>
                  <div class="event-type-wrpr">
                    <div class="conference">{result.event_type ==="CONFERENCE" ? "Conference":"Seminar"}</div>
                  </div>
                  
                </div>
                <div class="col-md-12">
                  <div class="event-desc hidden-items-wrpr">
                        <p>{ReactHtmlParser(desc)}</p>
                        {/* <a href="#" class="showmore">Show <span></span></a>
                        <div class="hidden-para">
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown</p>
                        </div> */}
                    </div>
                </div>
              </div>
            </div>
          </div>
          
          
          



          
          
          
          <div class="event-page-form-wrpr" style={{marginTop:'20px'}}>

            {/* <form> */}
              <div class="row">
                <div class="col-md-6">
                  <label>Select your school</label>
                  <select class="form-control" value={school} onChange={(e)=>{selectSchool(e)}}>
                      <option value="0">Select school</option>
                      {result.member_schools === "YES"?null:
                        <option>Non-member school</option>
                      }
                      {resultschool?.map((item, index)=>(
                        <option value={item.id}>{decode(item.name)}</option>
                      ))}
                  </select>
                  {schoolErr?<span style={{color:'red', fontSize:'13px', fontWeight:'500'}}>Select a school</span>:''}
                </div>


                <div class="col-md-6"></div>
                <div class="col-md-12">&nbsp;</div>


                {nonMem?
                  <div  className="col-md-12">
                    <div class="row">
                      <div className="col-md-6">
                      <label>School Name</label>  
                          <input className='form-control' value={orgName} onChange={(e)=>{setOrgName(e.target.value)}} placeholder="School Name" />
                      </div>
                    <div className="col-md-6">
                    <label>School City</label>  
                          <input className='form-control' value={orgCity} onChange={(e)=>{setOrgCity(e.target.value)}} placeholder="School City" />
                    </div>
                    
                    <div class="col-md-6 mt-4">
                      <label>School State:</label>
                      <select class="form-control" value={states ? states : "Select State"} onChange={(e) => { setStates(e.target.value); }}>
                          <option value="">Select State</option>
                          {statess.map((item, index) => (
                              <option value={item} key={index}>{item}</option>
                          ))}
                      </select>
                      {statesErr ? <span style={{ color: 'red', fontSize: '13px' }}>State is Required.</span> : null}
                    </div>
                    <div className="col-md-6  mt-4"  style={{ display: 'none' }}>
                      <label>School Country</label>  
                          <input className='form-control' value={orgCountry} onChange={(e)=>{setOrgCountry(e.target.value)}} placeholder="School Country" />
                    </div>
                    </div>
                  </div>:null}




                <div class="col-md-6"></div>
                <div class="col-md-12">&nbsp;</div>
                <div class="col-md-12">
                  <h3 class="mt-5 mb-4">Who can we contact concerning this registration?</h3>
                </div>
                <div class="col-md-6">
                  <label>First Name</label>
                  <input 
                    type="text" 
                    placeholder="Enter First Name" 
                    class="form-control"
                    value={fname} 
                    onChange={(e)=>{setFname(e.target.value)}}
                  />
                  <div class="mt-2">
                    {fnameVal?<span style={{color:'red',fontSize:'13px', fontWeight:'400'}}>Enter firstname</span>:''}
                  </div>
                </div>
                <div class="col-md-6">
                  <label>Last Name</label>
                  <input 
                    type="text" 
                    placeholder="Enter Last Name" 
                    class="form-control"
                    value={lname} 
                    onChange={(e)=>{setLname(e.target.value)}} 
                  />
                <div class="mt-2">
                {lnameVal?<span style={{color:'red',fontSize:'13px', fontWeight:'400'}}>Enter lastname</span>:''}
               </div>
                </div>
                <div class="col-md-6 mt-4">
                  <label>Email</label>
                  <input 
                    type="text" 
                    placeholder="Enter Email Address" 
                    class="form-control" 
                    value={email} 
                    onChange={(e)=>{setEmail(e.target.value); emailValidation(e.target.value)}} 
                  />
                <div class="mt-2">
                {emailVal?<span style={{color:'red',fontSize:'13px', fontWeight:'400'}}>Enter email</span>:''}
                {emailValid && !emailVal?<span style={{color:'red',fontSize:'13px', fontWeight:'400'}}>Enter valid email</span>:''}
                </div>
                </div>
                <div class="col-md-6  mt-4">
                  <label>Phone</label>
                  <input 
                    type="text" 
                    placeholder="Enter Phone Number" 
                    class="form-control" 
                    value={phone} 
                    onChange={(e)=>{setPhone(e.target.value)}} 
                  />
               <div class="mt-2">
                {phoneVal?<span style={{color:'red',fontSize:'13px', fontWeight:'400'}}>Enter phone</span>:''}
               </div>
                </div>



                {resultValid === "NOTSHOW"?null:
                <Fragment>
                <div class="col-md-6  mt-4">
                <label>Contact Title</label>
                <input 
                  type="text" 
                  placeholder="Enter Your Title" 
                  class="form-control" 
                  value={regtit} 
                  onChange={(e)=>{setRegTit(e.target.value)}} 
                />
                <div class="mt-2">
                {titVal?<span style={{color:'red',fontSize:'13px', fontWeight:'400'}}>Enter contact title</span>:''}
               </div>
            </div>
              <div class="col-md-6  mt-4" />
                </Fragment>

                }
                
                <div class="col-md-6  mt-4">
                  
                  <div class="custom-control custom-switch custom-switch-xl">
                    <input type="checkbox" class="custom-control-input" id="switch1" checked={addAtten} onChange={(e)=>{addToAttendee(e)}} />
                    <label class="custom-control-label" for="switch1">ADD this Contact Person as an ATTENDEE</label>
                    </div>
                </div>
         

                
                
                <div class="col-md-12 mt-3">
                  <hr />
                </div>



                {inputFields?.map((inputField, index) =>(
                <Fragment  key={`${inputField}~${index}`}>
                
                <div class="col-md-12">
                  <h3 class="mt-5 mb-4">Registration Information</h3>
                </div>
                <div class="col-md-6">
                  <label>First Name</label>
                  <input 
                  type="text" 
                  placeholder="Enter First Name" 
                  class="form-control" 
                  id="firstname"
                  name="firstname"
                  value={inputField.firstname}
                  onChange={event => {handleInputChange(index, event)}}
                  />
                    <div className='mt-2'>
                      {ferrind === index?
                        (
                          <div>
                            {ferr?<span style={{color:'red', fontSize:'13px', fontWeight:'500'}}>Enter firstname</span>:''}
                          </div>
                        ):null
                      }
                    </div>
                </div>
                <div class="col-md-6">
                  <label>Last Name</label>
                  <input 
                  type="text" 
                  placeholder="Enter First Name" 
                  class="form-control" 
                  id="lastname"
                  name="lastname"
                  value={inputField.lastname}
                  onChange={event => {handleInputChange(index, event)}}
                  />
                    <div className='mt-2'>
                      {lerrind === index?
                        (
                          <div>
                            {lerr?<span style={{color:'red', fontSize:'13px', fontWeight:'500'}}>Enter lastname</span>:''}
                          </div>
                        ):null
                      }
                    </div>
                </div>
                <div class="col-md-6 mt-4">
                  <label>Email</label>
                  <input 
                  type="text" 
                  placeholder="Enter Email Address" 
                  class="form-control" 
                  id="email"
                  name="email"
                  value={inputField.email}
                  onChange={event => {handleInputChange(index, event)}}
                  />
                      <div className='mt-2'>
                      {eerrind === index?
                        (
                          <div>
                            {eerr?<span style={{color:'red', fontSize:'13px', fontWeight:'500'}}>Enter email</span>:''}
                          </div>
                        ):null
                      }
                      {emailFormat1.status && emailFormat1.index === index?<span style={{color:'red', fontSize:'13px', fontWeight:'500'}}>Enter valid email</span>:''}
                    </div>
                </div>
                <div class="col-md-6  mt-4">
                  <label>Phone</label>
                  <input 
                  type="text" 
                  placeholder="Enter Phone Number" 
                  class="form-control" 
                  id="phone"
                  name="phone"
                  value={inputField.phone}
                  onChange={event => {handleInputChange(index, event)}}
                  />
                    <div className='mt-2'>
                      {perrind === index?
                        (
                          <div>
                            {perr?<span style={{color:'red', fontSize:'13px', fontWeight:'500'}}>Enter phone</span>:''}
                          </div>
                        ):null
                      }
                    </div>
                </div>

                {resultValid === "NOTSHOW"?null:
                <Fragment>
                <div class="col-md-6  mt-4">
                  <label>Contact Title</label>
                  <input 
                  type="text" 
                  placeholder="Enter Your Title" 
                  class="form-control" 
                  id="title"
                  name="title"
                  value={inputField.title}
                  onChange={event => {handleInputChange(index, event)}}
                  />
                    <div className='mt-2'>
                      {terrind === index?
                        (
                          <div>
                            {terr?<span style={{color:'red', fontSize:'13px', fontWeight:'500'}}>Enter your title</span>:''}
                          </div>
                        ):null
                      }
                    </div>
                </div>
                <div class="col-md-6  mt-4">
                </div>
                </Fragment>
                }

                <div class="col-md-12  mt-4">

                  <div class="workshop-form-list mt-5">
                    
                    <div class="row">                  
                    
                    <div class="col-md-7 mt-2">
                    {inputFields.length === (index+1)?
                      <button class="btn btn-primary remove-attendees" 
                        type="button"
                        disabled={index === 0}
                        style={{display:index ===0?'none':null}}
                        onClick={() => handleRemoveFields(index)}
                      >Remove Attendees<i class="icon-minus"></i></button>:null
                    }
                    {inputFields.length === (index+1)?
                      <button class="btn btn-primary addmore-attendees"
                      style={{marginLeft:index ===0?"0":"10px"}}
                      onClick={() => (result.max_number_attendees - result.attendee_count) -(index+1) === 0 ?messages.warning("No more seats left"):handleAddFields(index)}
                      >Add More Attendees<i class="icon-plus"></i></button>:null}
                    </div>
                    <div class="col-md-5 mt-2 text-right">
                      
                    {inputFields.length === (index+1)?
                      <button class="btn btn-primary paynow"
                      disabled={result.publish_status === "UNPUBLISHED"}
                      onClick={ValidationalFuction}
                      >{result?.participant_price > 0 ? "Pay Now" : "Register" }<i class="icon-dollar1"></i></button>:null
                    }

                  
                    </div>
                    
                    
                    </div>
                  </div>
                </div>

                </Fragment>
              ))}
 
              </div>
            {/* </form> */}
          </div>
          



          {/* {inputFields.length * (nonMem?result.non_member_price + dateDead :result.participant_price + dateDead  )} */}


          <Modal
        open={open}
        onClose={handleClose}
        onEntered={handleEntered}
        onExited={() => {
          setRows(0);
        }}
        style={{margin:'auto', top:'10%'}}
      >
        <Modal.Header>
          <Modal.Title><p style={{color:'#0072F5', fontWeight:'700'}}>Price Details</p></Modal.Title>
        </Modal.Header>
        <Grid.Container justify="center" style={{marginTop:'3%'}}>
            <Grid xs={8}>
              <Card css={{  $$cardColor: 'transparent' }}>
                        <span style={{fontSize:'15px', color:'#000', fontWeight:'500'}}>No of Attendees </span><br />
                        <span style={{fontSize:'15px', color:'#000', fontWeight:'500'}}>Amount (per attendee) </span><br />
                        <span style={{fontSize:'15px', color:'#000', fontWeight:'500'}}>Total Amount </span><br />
              </Card>
            </Grid>
            <Grid xs={2}>
              <Card css={{  $$cardColor: 'transparent' }}>
                        <span style={{fontSize:'15px'}}>:</span><br />
                        <span style={{fontSize:'15px'}}>:</span><br />
                        <span style={{fontSize:'15px'}}>:</span><br />
              </Card>
            </Grid>

            <Grid xs={2}>
              <Card css={{  $$cardColor: 'transparent' }}>
                        <span style={{fontSize:'15px'}}>{inputFields.length}</span><br />
                        <span style={{fontSize:'15px'}}>${nonMem?parseInt(result.non_member_price) + dateDead  :result.participant_price + dateDead}</span><br />
                        <span style={{fontSize:'15px'}}>${inputFields.length * (nonMem ? (parseInt(result.non_member_price) + dateDead) : (result.participant_price + dateDead))}</span><br />
              </Card>
            </Grid>
          </Grid.Container><br />

          <Grid.Container justify="center" style={{marginTop:'3%'}}>
            <Grid xs={2}>

              <Buttons type="primary" onClick={()=>{RegisterPayment("ONLINE", "PENDING")}}>
                Pay Online
              </Buttons>

            </Grid>
            <Grid  xs={2}>

            </Grid>
            <Grid xs={2}>

            <Buttons type="primary" onClick={()=>RegisterPayment("CHECK", "PENDING")}>
             Payment By Check
            </Buttons>

            </Grid>
          </Grid.Container>
          <div style={{ marginTop: '10px' }}>
            <b>For online registrations, only Visa, Mastercard, and Discover are accepted. If you want to pay by <span style={{ fontWeight: 'bold',color: 'red' }}>American Express</span>, please contact the GISA office.</b>
          </div>


      </Modal>







      <Modal
              className="modelPayment"
        open={modal1Open}
        onClose={handleClosePayment}
        // onEntered={handleEntered}
        // onExited={() => {
        //   setRows(0);
        // }}
        style={{margin:'auto'}}
      >

          <Grid.Container justify="center" style={{marginTop:'3%'}}>
            <AttendeePaymentSeminar paymentData={newData}/>
          </Grid.Container>

      </Modal>




      

        
      </div>
    </div>
    </aside>
    </div>
  );
}


export default PublicRegisteringSeminar;